import { render, staticRenderFns } from "./LogsTableSkeletonItem.vue?vue&type=template&id=5b841412&scoped=true"
import script from "./LogsTableSkeletonItem.vue?vue&type=script&lang=js"
export * from "./LogsTableSkeletonItem.vue?vue&type=script&lang=js"
import style0 from "./LogsTableSkeletonItem.vue?vue&type=style&index=0&id=5b841412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b841412",
  null
  
)

export default component.exports